var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "19,3 19,9 25,9 19,3 7,3 7,29 25,29 25,9 "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18,
    y1: 14,
    x2: 21,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18,
    y1: 18,
    x2: 21,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 22,
    x2: 21,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 12,
    x2: 13,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 19,
    x2: 13,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,13h-1.5c-0.8,0-1.5,0.7-1.5,1.5v0c0,0.8,0.7,1.5,1.5,1.5h1c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5 H12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.06e4bba81cc4463c47984927df74463b.svg";
export { ForwardRef as ReactComponent };